<script>
//活动核销
import VerifyModal from '@/components/lottery/activeVerify/index.vue';
export default {
  name:'marketing',
  components:{
    VerifyModal
  },
  data(){
    return{
      size1:10,
      page1:1,
      activeTab:'0',
      gameList:[],
      verifyModal:false
    }
  },
  watch:{
    // 监控参数变化更新游戏列表接口数据
    searchParams:function(newVal,oldVal) {
      if(newVal.status!==oldVal.status){
        this.page1 = 1;
        this.gameList = []
      }
      this.getListGame();
    },
  },
  computed:{
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        pageSize:this.size1,//每页数量
        pageNum:this.page1,//当前页码
        status:this.activeTab,// status:this.activeTab,//活动状态（0开启，1关闭）
      };
    },
  },
  methods:{
    handleVerify(data){
      console.log(data)
    },
    showModal(type){
      if(type==='verifyModal'){
        this.$router.push({path:'/marketList'})
      }
    },
    getListGame(){
      this.$http.marketingActivity_list(this.searchParams).then((res)=>{
        if(res){
          if(res.code===200){
            this.gameList = res.rows;
          }else{
            if(res.msg){
              this.$toast.fail(res.msg);
            }
          }
        }
      });
    },
  },
  created(){
    this.getListGame();
  }
}
</script>

<template>
  <div id="marketingPage" class="">
    <verify-modal v-model="verifyModal" @submit="handleVerify" />
    <div class="content">
      <div class="tabs">
        <van-tabs v-model="activeTab" animated swipeable sticky>
          <van-tab title="进行中" name="0"></van-tab>
          <van-tab title="已结束" name="1"></van-tab>
        </van-tabs>
      </div>
      <div class="tab-content active" v-if="gameList.length>0">
        <div class="activity-card" v-for="(item,index) in gameList" :key="index">
          <img :src="item.imageOssIdUrl" alt="活动图片" class="activity-image">
          <div class="activity-content">
            <div class="activity-title">{{ item.title }}</div>
            <div class="activity-desc">{{ item.description }}</div>
            <div class="activity-footer">
              <div class="activity-date" v-if="item.startTime&&item.endTime">{{ item.startTime&&item.startTime.substring(0,10) }} 至 {{ item.endTime&&item.endTime.substring(0,10) }}</div>
              <button class="btn btn-primary" @click="showModal('verifyModal')">核销</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card" style="text-align: center" v-else>
        暂无活动！
      </div>
      <div class="card" v-if="activeTab==='0'&&gameList.length>0">
        <div class="card-title">核销统计</div>
        <div class="card-info">
          <div class="info-labels">调查问卷活动</div>
          <div class="info-value">已核销：32次</div>
        </div>
        <div class="card-info">
          <div class="info-labels">公益打卡活动</div>
          <div class="info-value">已核销：45次</div>
        </div>
        <div class="card-info">
          <div class="info-labels">购票扫码活动</div>
          <div class="info-value">已核销：128次</div>
        </div>
      </div>
      <div class="card" v-if="activeTab==='1'&&gameList.length>0">
        <div class="card-title">活动成果</div>
        <div class="card-info">
          <div class="info-label">活动数量</div>
          <div class="info-value">2个</div>
        </div>
        <div class="card-info">
          <div class="info-label">总核销次数</div>
          <div class="info-value">187次</div>
        </div>
        <div class="card-info">
          <div class="info-label">带动销售</div>
          <div class="info-value">约23,450元</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.content{
  padding-top: 120px;
  box-sizing: border-box;
}
</style>